var _excluded = ["color", "checked", "disabled", "filledOnChecked", "label", "shape", "size", "textProps", "variant"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import DoneIcon from '@material-ui/icons/Done';
import { StyledCheckboxEl, StyledCheckbox, StyledCheckboxText, StyledCheckboxIcon } from './Styles';
import Text from '../Text';
function Checkbox(_ref) {
  var color = _ref.color,
    checked = _ref.checked,
    disabled = _ref.disabled,
    filledOnChecked = _ref.filledOnChecked,
    label = _ref.label,
    shape = _ref.shape,
    size = _ref.size,
    textProps = _ref.textProps,
    variant = _ref.variant,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledCheckboxEl, {
    disabled: disabled
  }, /*#__PURE__*/React.createElement(StyledCheckbox, _extends({
    color: color,
    checked: checked,
    disabled: disabled,
    size: size
  }, rest)), /*#__PURE__*/React.createElement(StyledCheckboxIcon, {
    color: color,
    shape: shape,
    size: size,
    variant: checked && filledOnChecked ? 'filled' : variant
  }, checked && /*#__PURE__*/React.createElement(DoneIcon, {
    fontSize: "inherit"
  })), /*#__PURE__*/React.createElement(StyledCheckboxText, null, /*#__PURE__*/React.createElement(Text, _extends({
    paragraph: false,
    as: "span",
    weight: "500",
    gutterBottom: false
  }, textProps), label)));
}
Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The color of the component. It supports those theme
   * colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'default', 'primary', 'primaryAlt', 'secondary', 'secondaryAlt', 'tertiary', 'error', 'warning', 'success', 'info']),
  /**
   * If `true`, component is checked by default.
   */
  // defaultChecked: PropTypes.bool,

  /**
   * If `true`, the Checkbox is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true` & checked is `true` will show filled variant.
   */
  filledOnChecked: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * Text to display after `input`
   */
  label: PropTypes.string.isRequired,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string.isRequired,
  /**
   * Callback fired when the state is changed.
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes.bool,
  /**
   * If `true`, shape in which checkbox need to appear in
   */
  shape: PropTypes.oneOf(['circular', 'square']),
  /**
   *
   */
  size: PropTypes.oneOf(['xxs', 'md']),
  /**
   * Props which are applicable to `Text` component.
   */
  textProps: PropTypes.object,
  /**
   * The value of the component. The DOM API
   * casts this to a string.
   */
  value: PropTypes.string,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['outlined', 'filled'])
} : {};
Checkbox.defaultProps = {
  checked: false,
  color: 'tertiary',
  disabled: false,
  filledOnChecked: false,
  id: '',
  onChange: function onChange() {},
  required: false,
  shape: 'square',
  size: 'md',
  textProps: {},
  value: '',
  variant: 'outlined'
};
export default Checkbox;